import { render, staticRenderFns } from "./Compact.vue?vue&type=template&id=58cf7704"
import script from "./Compact.vue?vue&type=script&lang=js"
export * from "./Compact.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports